module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external "angular-ui-bootstrap"
// module id = 20
// module chunks = 0